import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteRole, getAllRoles,createRole,editRole,getOneRole } from '../../api/axiosRoles';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';







const Roles = () => {
  const { roles, setRoles, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [roleName, setRoleName] = useState("");
  const [roleDescription, setRoleDescription] = useState("");
  const [editedRoleName, setEditedRoleName] = useState("");
  const [editedRoleDescription, setEditedRoleDescription] = useState("");


  // console.log("ObtainedRole", role);

  const NewTitle = "All Roles";
  useEffect(() => {
    
    getAllRoles(setRoles, setFetcherror);
    
  }, []);


  const filteredRoles = roles.filter((item) => item.name.toLowerCase().includes(globalFilter) || item.description.toLowerCase().includes(globalFilter))
  const filteredReversedRoles = filteredRoles.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setRoles, setFetcherror, handleAllToasts) => {
    return () => {
      deleteRole(pkid, setRoles, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Role?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedRoleName(foundItem?.name);
    setEditedRoleDescription(foundItem?.description);
   }

  const deleteDisable = true;
  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
        <SearchToolBar
            setAddItemDialogVisible={setAddItemDialogVisible}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            searchPlaceholder="Roles"
            createLabel="Role"
        />  
        
        <DataTable
          value={filteredRoles}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No roles found"
        >
                    <Column header="S/N" body={(rowData) => roles.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Role"   body={(rowData) => (rowData.name)} sortable></Column>
                    <Column header="Description" body={(rowData) => rowData.description} sortable></Column>
                    <Column header="Actions" body={(rowData) => (
                            <TableActions
                                id={rowData.id}
                                data={roles}
                                getItemtoEdit={getItemtoEdit}
                                setSelectedId={setSelectedId}
                                setEditDialogVisible={setEditDialogVisible}
                                setDeleteDialogVisible={setDeleteDialogVisible}
                                deleteDisable={deleteDisable }
                          />
                           
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Role" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createRole(roleName, setRoleName, roleDescription, setRoleDescription, setFetcherror, handleAllToasts, setRoles);
                if (roleName || roleDescription) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Role Name"
                    value={roleName}
                    onChange={(e) => setRoleName(e.target.value)}
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Role Description"
                    value={roleDescription}
                    onChange={(e) => setRoleDescription(e.target.value)}
                    />
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setRoleName(""); setRoleDescription("") }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Role" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editRole( selectedId, editedRoleName, setEditedRoleName, editedRoleDescription, setEditedRoleDescription, setFetcherror, handleAllToasts, setRoles);
                if (editedRoleName || editedRoleDescription) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    disabled
                    placeholder="Enter Role Name"
                    value={editedRoleName}
                    onChange={(e) => setEditedRoleName(e.target.value)}
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Role Description"
                    value={editedRoleDescription}
                    onChange={(e) => setEditedRoleDescription(e.target.value)}
                    />
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setRoleName(""); setRoleDescription("") }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setRoles, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Roles